import loadGNB from './gnb.wrapper';

function _sendApi(url, data, successCallback, failureCallback) {
  return $.ajax({
    type: 'POST',
    url,
    data,
    success(response, textStatus, jqXHR) {
      if (response.success) {
        _refreshGnb();
        successCallback();
      } else if (typeof failureCallback === 'function') {
        failureCallback(jqXHR, response);
      }
    },

    error(jqXHR) {
      if (typeof failureCallback === 'function') {
        failureCallback(jqXHR);
      }
    },
  });
}

function _refreshGnb() {
  if (Ridi.globals.isMobile) return;
  loadGNB().then(GNB => {
    // 모바일에서는 GNB에서 카트/위시가 없어서 있는지 먼저 체크
    if (typeof GNB.refreshWishlistLayer === 'function') {
      GNB.refreshWishlistLayer();
    }
  });
}

const wishlist = {
  add(bookIds, seriesId, csrfToken, successCallback, failureCallback) {
    const data = {
      b_ids: bookIds,
      _token: csrfToken,
    };

    return _sendApi('/wishlist/add', data, successCallback, failureCallback);
  },

  remove(bookIds, csrfToken, successCallback, failureCallback) {
    const data = {
      b_ids: bookIds,
      _token: csrfToken,
    };

    return _sendApi('/wishlist/remove', data, successCallback, failureCallback);
  },

  moveToCart(bookIds, csrfToken, successCallback, failureCallback) {
    const data = {
      b_ids: bookIds,
      _token: csrfToken,
    };

    return _sendApi('/wishlist/move-to-cart', data, successCallback, failureCallback);
  },
};

export default wishlist;



// WEBPACK FOOTER //
// ./common/wishlist.lib.js